import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {PageComponent} from "../../../../core/shared/mvs-page/page.component";

@Component({
    selector: 'mvs-example',
    templateUrl: './contract-overview.page.html',
    styleUrls: ['contract-overview.page.scss'],
    standalone: false
})
export class ContractOverviewPage extends PageComponent implements OnInit, OnChanges, OnDestroy {

    defaultLabel: string = "Contract Overview";

    ngOnInit(): void {
        super.ngOnInit();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        this.initialized = true;

    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
